/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef, useEffect, useState, useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
// import { Chart as ChartJS, registerables } from 'chart.js';
// import { Chart } from 'react-chartjs-2'
// ChartJS.register(...registerables);
// import 'chartjs-adapter-moment';

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Soft UI Dashboard PRO React helper functions
import gradientChartLine from "assets/theme/functions/gradientChartLine";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//Backend access
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { getLogs } from '../../../api/bks';

import { Route, Link, Routes, useLocation, useNavigate, useMatch } from 'react-router-dom';
import moment from "moment";

import GradientMinMaxLineChart from "nextus/Charts/GradientMinMaxLineChart/stats"

import EventSelects from "nextus/Charts/Selectors/Events";
import DeviceEventsChart from "nextus/Charts/DeviceEventsChart";

// @mui material components
import Grid from "@mui/material/Grid";

function getGroupSize(start, end) {
    var gap = end - start;
    return (gap) / 40;
}

function DeviceEvents({ title = "", height = "19.125rem", uuid }) {
    const [startTime, setStartTime] = useState(moment().subtract(2, "days"));
    const [endTime, setEndTime] = useState(moment());
    const [advancedToggle, setAdvancedToggle] = useState(false);
    const groupSize = getGroupSize(startTime.unix(), endTime.unix());

    return (
        <SoftBox>
            <EventSelects {...{ startTime, setStartTime, endTime, setEndTime, advancedToggle, setAdvancedToggle }} />
            <Grid container spacing={{xxs: 1, xs: 3}}>
                <Grid item xxs={12}>
                    <DeviceEventsChart  {...{ uuid, advancedToggle, startTime, setStartTime, endTime, setEndTime, groupSize, height }} />
                </Grid>
            </Grid>
        </SoftBox>
    );
}

// Typechecking props for the DeviceEvents
DeviceEvents.propTypes = {
    title: PropTypes.string,
    uuid: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DeviceEvents;

